// Mesmo desenho de public/favicon.svg (cadeado), com a cor de fundo parametrizada
const buildFaviconSvg = (color: string): string =>
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">` +
    `<rect width="64" height="64" rx="12" fill="${color}"/>` +
    `<rect x="22" y="28" width="20" height="16" rx="2" fill="white"/>` +
    `<path d="M 26 28 L 26 22 Q 26 16, 32 16 Q 38 16, 38 22 L 38 28" stroke="white" stroke-width="3" fill="none" stroke-linecap="round"/>` +
    `<circle cx="32" cy="34" r="2.5" fill="${color}"/>` +
    `<rect x="30.5" y="34" width="3" height="5" rx="1" fill="${color}"/>` +
    `</svg>`;

// Aplica a cor do módulo ao favicon e à barra do navegador (meta theme-color)
export const applyModuleFavicon = (color: string): void => {
    const href = `data:image/svg+xml,${encodeURIComponent(buildFaviconSvg(color))}`;

    document.querySelectorAll<HTMLLinkElement>('link[rel~="icon"]').forEach((link) => {
        link.type = 'image/svg+xml';
        link.href = href;
    });

    document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute('content', color);
};
